(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const sortProductsByAvailability = () => {
    const grid = document.querySelector('ul[id^="ResultsList"], .product-grid__list, ul.product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.product-grid__item[data-available]'));
    if (!items.length) return;

    const inStock = items.filter(item => item.dataset.available === 'true');
    const outOfStock = items.filter(item => item.dataset.available !== 'true');

    const fragment = document.createDocumentFragment();
    [...inStock, ...outOfStock].forEach(item => fragment.appendChild(item));
    grid.appendChild(fragment);
  };

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(sortProductsByAvailability, 300);
    setTimeout(sortProductsByAvailability, 1000);
  });

  } catch(e) { console.error(e); }
})();
})();
